import {stringify} from "comment-json";
import {ElementsTree} from "../../../../model/ElementsTree";
import {Graph, NodeType} from "../../../../model/Graph";
import {Playshot} from "../../../../model/Playshot";
import {getService, nodeLabel, removeDefaultService} from "../../default-service";
import {PlayshotChanged} from "../PlayshotChanged";
import {PageAdded} from "./PageAdded";
import {PageMetadataChanged} from "./PageMetadataChanged";
import {PageRemoved} from "./PageRemoved";

export const comparePages = (oldPlayshot: Playshot, newPlayshot: Playshot, graph: Graph, elementsTree: ElementsTree): PlayshotChanged[] => {
  const oldPages = oldPlayshot.playConfig.pages;
  const newPages = newPlayshot.playConfig.pages;

  const changeSet: PlayshotChanged[] = [];

  const oldPageNames = Object.keys(oldPages).filter(n => n !== "Welcome" && n !== "CodyPlay.VibeCodyProcessing");
  const newPageNames = Object.keys(newPages).filter(n => n !== "Welcome" && n !== "CodyPlay.VibeCodyProcessing");

  const pagesToRemove: string[] = oldPageNames.filter(oldPageName => !newPageNames.includes(oldPageName));
  const pagesToAdd: string[] = newPageNames.filter(newPageName => !oldPageNames.includes(newPageName));

  const changedPages: string[] = newPageNames.filter(newPageName => {
    if(pagesToAdd.includes(newPageName)) {
      return false;
    }

    const oldPage = oldPages[newPageName];
    const newPage = newPages[newPageName];

    return stringify(oldPage) !== stringify(newPage);
  });

  pagesToAdd.forEach(pageNameToAdd => {
    const pageToAdd = newPages[pageNameToAdd];

    const pageLabel = nodeLabel(pageNameToAdd);
    const similarPages = elementsTree.getFilteredElementsByTypeAndLabel(NodeType.ui, pageLabel, getService(pageToAdd, newPlayshot));

    const nodeId = similarPages.map(p => p.getId()).first(undefined) || graph.createCellId();

    // @TODO: Currently, we have no chance to detect a renamed page, because pages don't keep a reference to the UI card.
    // cody play should be changed, to track prooph board info for pages as well

    changeSet.push(new PageAdded(
      pageToAdd.name,
      nodeId,
      pageToAdd)
    );
  });

  changedPages.forEach(pageNameToUpdate => {
    const pageToUpdate = newPages[pageNameToUpdate];

    const pageLabel = nodeLabel(pageNameToUpdate);
    const similarPages = elementsTree.getFilteredElementsByTypeAndLabel(NodeType.ui, pageLabel, getService(pageToUpdate, newPlayshot));

    const nodeId = similarPages.map(p => p.getId()).first(undefined) || graph.createCellId();

    changeSet.push(new PageMetadataChanged(pageNameToUpdate, nodeId, pageToUpdate, newPlayshot, oldPlayshot));
  });

  pagesToRemove.forEach(pageNameToRemove => {
    const oldPage = oldPages[pageNameToRemove];

    const pageLabel = nodeLabel(pageNameToRemove);
    const similarPages = elementsTree.getFilteredElementsByTypeAndLabel(NodeType.ui, pageLabel, getService(oldPage, newPlayshot));

    const nodeId = similarPages.map(p => p.getId()).first(undefined) || graph.createCellId();


    changeSet.push(new PageRemoved(pageNameToRemove, nodeId, oldPage, oldPlayshot));
  })

  return changeSet;
}
